(function () {
  const DEFAULT_OFFSET = 126;

  function alignBloggleSidebar() {
    const sidebar = document.getElementById('bloggle_sideBar');
    const hero = document.querySelector('#article > img.bloggle--blog-item-img');

    if (!sidebar || !hero) return;

    if (window.innerWidth < 1200) {
      sidebar.style.marginTop = '';
      return;
    }

    /*
     * Temporarily reset so we can measure the natural
     * sidebar position accurately.
     */
    sidebar.style.marginTop = '0px';

    const heroTop = hero.getBoundingClientRect().top;
    const sidebarTop = sidebar.getBoundingClientRect().top;

    const offset = Math.max(0, heroTop - sidebarTop);

    sidebar.style.marginTop = offset + 'px';
  }

  document.addEventListener('DOMContentLoaded', alignBloggleSidebar);
  window.addEventListener('load', alignBloggleSidebar);
  window.addEventListener('resize', alignBloggleSidebar);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(alignBloggleSidebar);
  }
})();